import { NavLink, useLocation } from 'react-router';
import NavbarButton from './NavbarButton';
import { FC, useCallback } from 'react';
import clsx from 'clsx';

interface NavLinkBtnProps {
  path: string;
  title: string;
}

const NavLinkBtn: FC<NavLinkBtnProps> = ({ path, title }) => {
  const location = useLocation();

  const computeIsActive = useCallback(
    () => location.pathname.startsWith(path),
    [location.pathname, path],
  );

  return (
    <NavLink
      to={path}
      className={clsx({
        'bg-brand-50 rounded-md text-brand-600': computeIsActive(),
      })}
    >
      {({ isActive }) => <NavbarButton title={title} isActive={isActive} />}
    </NavLink>
  );
};

export default NavLinkBtn;
